import { setPagination } from '../__archive/pagination';
import { blogPost } from '../__utils/_alignment/alignmentController';
import { closeFilters } from '../__archive/filterToggle';

const $ = jQuery.noConflict();
const container = $('.posts-main-wrapper .row');
let $allowAjax = true;
const offset = $('.posts-main-wrapper').attr('data-offset') * 1;
let currentOffset = offset;
const paginationBtn = '.pagination-wrapper .pagination-btn, .pagination-wrapper .pagination-arr';
const term = [];
const paginationWrapper = $('.pagination-main-wrapper');
const selectedWrapper = $('.selected-categories-wrapper');
let checkPaginationLoad = false;
const filterActive = false;

function postsAjax(offs, num, term, filterActive) {
    if ($allowAjax) {
        $allowAjax = false;
        $.ajax({
            type: 'POST',
            url: WP.ajaxUrl,
            data: {
                action: 'posts_more',
                offset: offs,
                num,
                term,
            },
            // dataType: 'html',

            success(response) {
                $allowAjax = true;

                const pagination = $(response).filter('.pagination-wrapper');
                const article = $(response).filter('article');
                container.find('.ajax-loader').remove();

                if (response) {
                    // container.append(response);

                    container.append(article);
                    if ((term.length !== 0) && filterActive) {
                        checkPaginationLoad = true;
                        paginationWrapper.find('.pagination-wrapper').remove();
                        paginationWrapper.append(pagination);
                        filterActive = false;
                    } else if ((term.length == 0) && (checkPaginationLoad)) {
                        paginationWrapper.find('.pagination-wrapper').remove();
                        paginationWrapper.append(pagination);
                        checkPaginationLoad = false;
                    }
                    const height = $('.main-header').outerHeight();
                    $('html, body').animate({
                        scrollTop: $('.posts-main-wrapper').offset().top - height,
                    }, 400);
                }
            },
            complete() {
                blogPost.init();
                setPagination();
            },
            error(response) {
                console.log(response);
            },
        });
    }
}

function paginatePages(e, filterActive) {
    e.preventDefault();
    let pageNum = $(this).attr('data-pagination');
    const selected = $('.selected-term');
    let tag = [];
    selected.each((index, element) => {
        tag.push($(element).attr('data-filter'));
    });
    tag = tag.map(Number);

    if ($allowAjax && !$(this).hasClass('active')) {
        container.html('<span class="ajax-loader"></span>');

        if (!$(this).hasClass('pagination-arr')) {
            $(this).addClass('active');
            $(this).siblings('.active').removeClass('active');
        } else {
            const activeBtn = $('.pagination-btn.active');

            if ($(this).hasClass('arr-next')) {
                pageNum = activeBtn.next().attr('data-pagination');
                activeBtn.next().addClass('active').siblings().removeClass('active');
            }
            if ($(this).hasClass('arr-prev')) {
                if (activeBtn.prev().attr('data-pagination') == undefined) {
                    pageNum = activeBtn.prevAll().eq(1).attr('data-pagination');
                    activeBtn.prevAll().eq(1).addClass('active').siblings()
.removeClass('active');
                } else {
                    pageNum = activeBtn.prev().attr('data-pagination');
                    activeBtn.prev('.pagination-btn').addClass('active').siblings().removeClass('active');
                }
            }
        }
        currentOffset = (pageNum - 1) * offset;
        postsAjax(currentOffset, offset, tag, filterActive);
    }
}

function filters(e) {
    e.preventDefault();
    if ($(this).hasClass('selected-term') || $(this).hasClass('selected-filter')) {
        $(this).removeClass('selected-term');

        selectedWrapper.find($(this)).remove();
        const dataItem = $(this).attr('data-filter');
        const checkItem = term.indexOf(dataItem);
        if (checkItem > -1) {
            term.splice(checkItem, 1);
        }
    } else {
        $(this).addClass('selected-term');
        const filter = $(this).clone().addClass('selected-filter');
        filter.removeClass('selected-term');
        selectedWrapper.append(filter);
        closeFilters();
        const selectedCat = $('.selected-term').not('selected-filter');
        selectedCat.each((index, element) => {
            const dataFilter = $(element).attr('data-filter');
            if (!term.includes(dataFilter)) {
                term.push(dataFilter);
            }
        });
    }

    paginatePages(e, true);
}

function selectedFilters(e) {
    e.preventDefault();
    const filter = $(e.currentTarget).attr('data-filter');
    $(`[data-filter =${filter}]`).removeClass('selected-term');
    $(this).remove();
    paginatePages(e, true);
}

function initPagAjax() {
    if ($('.blog').length > 0) {
        $('body').on('click', paginationBtn, paginatePages);
        $('.single-term').on('click', filters);
        $(document).on('click', '.selected-filter', selectedFilters);
    }
}

export default initPagAjax;

